import apiClient from './apiClient';

export const foncierAPI = {
  cases: {
    list: (params) => apiClient.get('/foncier/cases/', { params }),
    get: (id) => apiClient.get(`/foncier/cases/${id}/`),
    create: (data) => apiClient.post('/foncier/cases/', data),
    update: (id, data) => apiClient.put(`/foncier/cases/${id}/`, data),
    delete: (id) => apiClient.delete(`/foncier/cases/${id}/`),
  },
  acquisitions: {
    list: (params) => apiClient.get('/foncier/acquisitions/', { params }),
    get: (id) => apiClient.get(`/foncier/acquisitions/${id}/`),
    create: (data) => apiClient.post('/foncier/acquisitions/', data),
    update: (id, data) => apiClient.put(`/foncier/acquisitions/${id}/`, data),
    delete: (id) => apiClient.delete(`/foncier/acquisitions/${id}/`),
    advanceStage: (id) => apiClient.post(`/foncier/acquisitions/${id}/advance_stage/`),
  },
  expropriations: {
    list: (params) => apiClient.get('/foncier/expropriations/', { params }),
    get: (id) => apiClient.get(`/foncier/expropriations/${id}/`),
    create: (data) => apiClient.post('/foncier/expropriations/', data),
    update: (id, data) => apiClient.put(`/foncier/expropriations/${id}/`, data),
    delete: (id) => apiClient.delete(`/foncier/expropriations/${id}/`),
  },
  immatriculations: {
    list: (params) => apiClient.get('/foncier/immatriculations/', { params }),
    get: (id) => apiClient.get(`/foncier/immatriculations/${id}/`),
    create: (data) => apiClient.post('/foncier/immatriculations/', data),
    update: (id, data) => apiClient.put(`/foncier/immatriculations/${id}/`, data),
    delete: (id) => apiClient.delete(`/foncier/immatriculations/${id}/`),
  },
  servitudes: {
    list: (params) => apiClient.get('/foncier/servitudes/', { params }),
    get: (id) => apiClient.get(`/foncier/servitudes/${id}/`),
    create: (data) => apiClient.post('/foncier/servitudes/', data),
    update: (id, data) => apiClient.put(`/foncier/servitudes/${id}/`, data),
    delete: (id) => apiClient.delete(`/foncier/servitudes/${id}/`),
  },
  technicalFiles: {
    list: (params) => apiClient.get('/foncier/technical-files/', { params }),
    get: (id) => apiClient.get(`/foncier/technical-files/${id}/`),
    create: (data) => apiClient.post('/foncier/technical-files/', data),
    update: (id, data) => apiClient.put(`/foncier/technical-files/${id}/`, data),
    delete: (id) => apiClient.delete(`/foncier/technical-files/${id}/`),
  },
};
